export type PropertyFeatureGroup = {
  key: string;
  label: string;
  options: string[];
};

export const PROPERTY_FEATURE_GROUPS: PropertyFeatureGroup[] = [
  { key: "exterior", label: "Exterior y piscina", options: ["Piscina privada", "Piscina climatizada", "Jacuzzi", "Jardín", "Terraza", "Barbacoa", "Comedor exterior", "Tumbonas", "Vistas al mar", "Vistas a la montaña", "Vistas a la piscina"] },
  { key: "comfort", label: "Confort", options: ["WiFi", "Aire acondicionado", "Calefacción", "TV", "Lavadora", "Secadora", "Plancha", "Chimenea", "Caja fuerte"] },
  { key: "kitchen", label: "Cocina", options: ["Cocina equipada", "Horno", "Lavavajillas", "Microondas", "Cafetera", "Tostadora", "Frigorífico", "Congelador"] },
  { key: "family", label: "Familias", options: ["Cuna", "Trona", "Juegos infantiles", "Valla de piscina", "Alojamiento familiar"] },
  { key: "accessibility", label: "Accesibilidad y servicios", options: ["Planta baja", "Acceso adaptado", "Ascensor", "Check-in autónomo", "Aparcamiento privado", "Aparcamiento gratuito", "Se admiten mascotas"] },
  { key: "safety", label: "Seguridad", options: ["Detector de humo", "Extintor", "Botiquín", "Detector de monóxido de carbono"] },
];

export const PROPERTY_FEATURES = PROPERTY_FEATURE_GROUPS.flatMap((group) => group.options);
